import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const InputDropdown = ({
  data,
  selectedItem,
  onSelect,
  placeholder,
  setFieldTouched,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    const match = data.find((item) => item.value === selectedItem);
    setSelectedLabel(match ? match.label : selectedItem === "other" ? "Other" : selectedItem);
  }, [selectedItem, data]);

  const handleSelect = (item) => {
    onSelect(item.value);
    setSelectedLabel(item.label);
    setFieldTouched("subCat");
    setOpen(false);
    setInputValue(""); // reset filter input
  };

  useEffect(() => {
    const newData = data.filter((item) =>
      item.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredData(newData);
  }, [inputValue, data]);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        disabled={!data.length}
        className="w-full flex justify-between text-left px-3 py-2 border border-gray-300 rounded bg-white text-sm font-[Gilroy-Regular] text-[#0D1C2E]">
        
        <span>{selectedLabel || placeholder}</span>
        {open? 
          <KeyboardArrowUpIcon fontSize="small" />:
          <KeyboardArrowDownIcon fontSize="small" />
        }
      </button>

      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded shadow flex flex-col">
          <input
            maxLength={40}
            onChange={(e) => setInputValue(e.target.value)}
            value={inputValue}
            placeholder="Enter sub-cat"
            className="m-1 border border-gray-300 rounded-lg px-3 py-2 text-sm text-[#0D1C2E] font-[Gilroy-Regular] focus:outline-none focus:ring focus:ring-gray-200"
          />

          <ul className="max-h-48 overflow-y-auto">
            {filteredData.map((item) => (
              <li
                key={item.value}
                onClick={() => handleSelect(item)}
                className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 text-[#0D1C2E]">
                {item.label}
              </li>
            ))}

            {/* Always show "Other" */}
            <li
              onClick={() => handleSelect({ label: "Other", value: "other" })}
              className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 text-[#0D1C2E]">
              Other
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default InputDropdown;
